module.exports = "/_next/static/images/e3f5b468a17ec9327654a92537ccb5cd-slide3desktop.jpg.webp";